// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryList_root__QwT7j","list":"CategoryList_list__9_ZSf"};